class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.updateFreeShippingProgress();
    this.open();
  }

   async updateFreeShippingProgress() {
    const progressBox = this.querySelector('[data-free-shipping-progress]');
    if (!progressBox) return;

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      if (!response.ok) return;

      const cart = await response.json();
      progressBox.hidden = cart.item_count === 0;
      const threshold = Number(progressBox.dataset.threshold) || 4000;
      const cartTotal = cart.total_price;
      const amountRemaining = Math.max(threshold - cartTotal, 0);
      const percentage = Math.min((cartTotal / threshold) * 100, 100);

      const message = progressBox.querySelector('[data-free-shipping-message]');
      const remaining = progressBox.querySelector('[data-free-shipping-remaining]');
      const fill = progressBox.querySelector('[data-free-shipping-fill]');
      const track = progressBox.querySelector('[data-free-shipping-track]');
      const cartTotalText = progressBox.querySelector('[data-free-shipping-cart-total]');

      const currency = cart.currency || Shopify.currency.active || 'USD';
      const locale = document.documentElement.lang || 'en-US';
      const formatMoney = (cents) =>
        new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
        }).format(cents / 100);

      fill.style.width = `${percentage}%`;
      track.setAttribute('aria-valuenow', Math.round(percentage));

      if (cartTotal >= threshold) {
        progressBox.classList.add('free-shipping-progress--unlocked');
        message.innerHTML = "You've unlocked <strong>FREE shipping</strong>!";
        cartTotalText.hidden = true;
      } else {
        progressBox.classList.remove('free-shipping-progress--unlocked');
        remaining.textContent = formatMoney(amountRemaining);
        cartTotalText.textContent = `${formatMoney(cartTotal)} in your cart`;
        cartTotalText.hidden = false;
      }
    } catch (error) {
      console.error('Free shipping progress error:', error);
    }
  }
  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
